import styled, { keyframes } from "styled-components";

import { Link } from "react-router-dom";

import foto from "../../../assets/foto.jpg";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const scale = keyframes`
  from {
    transform: scale(1.5);
  }
  to {
    transform: scale(1.0);

  }
`;

const rotate = keyframes`
  15% {
    transform: rotate(2deg);
  }
  30% {
    transform: rotate(-2deg);
  }
  45% {
    transform: rotate(2deg);
    transform: scale(1.2);
  }
  60% {
    transform: rotate(-2deg);
  }
  75% {
    transform: rotate(2deg);
  }
  90% {
    transform: rotate(-2deg);
  }
  100% {
    transform: rotate(0deg);
    transform: scale(1.0);
  }
`;

const typing = keyframes`
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`;

const blinkCursor = keyframes`
  from {
    border-right-color: rgba(0, 0, 0, 0.75);
  }
  to {
    border-right-color: transparent;
  }
`;

export const BannerContainer = styled.section`
  width: 100%;
  height: 250px;
  align-self: center;
  margin: 0px 10px;
  padding-bottom: 30px;
  position: relative;

  background-image: url(${foto});
  background-size: 100%;
  background-position: 0px -40px;

  color: var(--white);

  font-size: clamp(16px, 16px + 1vw, 30px);

  text-shadow: 2px 2px 2px var(--black);
  border-radius: 10px 10px 10px 10px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  ::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;

    background-color: #ccc5;
    z-index: 0;
  }

  > p {
    margin: 5px 20px;

    animation: ${fadeIn} 0.8s, ${scale} 0.6s;
    transition: 0.2s;

    user-select: none;

    z-index: 1;

    :hover {
      margin-left: 40px;
    }
  }

  > button {
    animation: ${fadeIn} 0.8s, ${rotate} 0.6s 0.4s;
    margin-top: 30px;

    z-index: 1;

    background: radial-gradient(
      circle at bottom,
      var(--gradientPrimary) 50%,
      var(--gradientSecondary) 150%
    );

    :hover {
      transform: scale(1.1);
    }
  }
  @media (max-width: 768px) {
    height: fit-content;
    background-repeat: no-repeat;
    background-size: 150%;

    > div > button {
      font-size: 13px;
    }
  }

  @media (max-width: 425px) {
    background-size: 300% auto;
    background-position-x: -100px;
  }
`;

// export const TextoBanner1 = styled.p`
//   opacity: 0;
//   animation: ${fadeIn} 0.2s, ${slideRight} 0.2s;
// `;

export const Content = styled.div`
  width: 80%;
  height: fit-content;
  margin: 40px 10px;

  border-radius: 10px;

  overflow: hidden;

  animation: ${fadeIn} 0.4s;

  position: relative;

  > h1 {
    margin: 15px;
    white-space: nowrap;
    overflow: hidden;

    font-size: clamp(8px, 8px + 1vw, 30px);

    color: var(--primary);

    /* border-right: 2px solid #fffa;
    ${blinkCursor} 500ms steps(40) infinite normal, */

    animation: ${typing} 1.2s steps(50) 0.5s normal both;

    /* @media (max-width: 768px) {
      font-size: 1em;
    }

    @media (max-width: 425px) {
      margin: 15px;
      font-size: 0.8em;
    } */
  }

  @media (max-width: 425px) {
    width: 90%;
    margin: 40px 10px;
  }
`;

export const Card = styled.section`
  padding: 10px;
  background-color: var(--white);
  margin: 10px;

  border-radius: 10px;
  border: 1px solid var(--gray);
  box-shadow: 2px 2px 5px;

  animation: ${fadeIn} 0.4s;

  > h1 {
    font-size: 25px;
    margin-bottom: 30px;
  }
`;

export const DashContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px;
`;

export const LinkMenu = styled(Link)`
  color: var(--black);
  width: 100px;

  text-decoration: none;
  font-weight: bold;

  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.6;
  }
`;

export const Notificacao = styled.section`
  padding: 10px;
  margin-bottom: 5px;

  border-radius: 10px;
  border: solid var(--black) 1px;
  color: var(--black);

  display: flex;
  align-items: center;

  > section {
    flex: 1;

    cursor: pointer;

    :hover {
      color: var(--darkGreen);
      opacity: 0.8;
    }

    :active {
      opacity: 0.4;
    }

    > p {
      margin-top: 4px;
    }
  }

  > span {
    font-size: 30px;
    margin-left: 50px;

    cursor: pointer;

    :hover {
      color: var(--primary);
      opacity: 0.8;
    }

    :active {
      opacity: 0.4;
    }
  }
`;
